import { render, staticRenderFns } from "./CustomerImportStatus.vue?vue&type=template&id=1fb54b30&"
import script from "./CustomerImportStatus.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports